import { render, staticRenderFns } from "./GLTF.vue?vue&type=template&id=1c152fa0&scoped=true"
import script from "./GLTF.vue?vue&type=script&lang=js"
export * from "./GLTF.vue?vue&type=script&lang=js"
import style0 from "./GLTF.vue?vue&type=style&index=0&id=1c152fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c152fa0",
  null
  
)

export default component.exports